import { render, staticRenderFns } from "./CameraImage.vue?vue&type=template&id=548ea956&scoped=true"
import script from "./CameraImage.vue?vue&type=script&lang=js"
export * from "./CameraImage.vue?vue&type=script&lang=js"
import style0 from "./CameraImage.vue?vue&type=style&index=0&id=548ea956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ea956",
  null
  
)

export default component.exports